<header id="page-topbar">
    <div class="navbar-header">
        <div class="d-flex">
            <!-- LOGO -->
            <div class="navbar-brand-box">
                <a routerLink="/dashboard" class="logo logo-light" *ngIf="!currentUser.isVanosUser">
                    <span class="logo-sm">
                        <img src="assets/images/logo-white.png" alt="" height="40">
                    </span>
                    <span class="logo-lg">
                        <img src="assets/images/logo-white.png" alt="" width="25%">
                    </span>
                </a>
                <a routerLink="/dashboard" class="logo logo-light" *ngIf="currentUser.isVanosUser">
                    <span class="logo-sm">
                        <!-- <img src="assets/images/logo-white.png" alt="" height="40" > -->
                        <img src="assets/images/logo-2.png" alt="" height="40" width="80%">
                    </span>
                    <span class="logo-lg">
                        <!-- <img src="assets/images/logo-white.png" alt="" width="25%"> -->
                        <img src="assets/images/logo-2.png" alt="" height="25%" width="80%">
                    </span>
                </a>
            </div>

            <button type="button" class="btn btn-sm px-0 font-size-16 header-item" id="vertical-menu-btn"
                (click)="toggleMobileMenu($event)">
                <i class="fa fa-fw fa-bars"></i>
            </button>

            <!-- App Search-->
            <!-- <form class="app-search d-none d-xl-block">
                <div class="position-relative">
                    <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}">
                    <span class="bx bx-search-alt"></span>
                </div>
            </form> -->

        </div>

        <div class="d-flex">
            <!-- <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
                <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown"
                    data-toggle="dropdown" aria-haspopup="true" ngbDropdownToggle aria-expanded="false">
                    <i class="mdi mdi-magnify"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
                    aria-labelledby="page-header-search-dropdown">
                    <form class="p-3">
                        <div class="m-0">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Search ..."
                                    aria-label="Recipient's username">
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="submit"><i
                                            class="mdi mdi-magnify"></i></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div> -->
            <!-- new code -->
            <div class="dropdown  d-lg-inline-block"
                *ngIf="currentUser.role == Roles.CompanyAdmin || currentUser.role == Roles.SuperAdmin">
                <button type="button" class="btn header-item" placement="top" routerLink="synchronize">
                    Synchronization
                </button>
            </div>

            <div class="dropdown  d-lg-inline-block">
                <button type="button" class="btn header-item noti-icon" n routerLink="Wizard">
                    <!-- <i class="fas fa-headset"></i> -->
                    <i class="fas fa-play-circle"></i>
                </button>
            </div>
            <div class="dropdown  d-none">
                <button type="button" class="btn header-item noti-icon" ngbtooltip="Lemur Maritime Wizard"
                    placement="top" routerLink="NotificationDetail">
                    <!-- <i class="fas fa-headset"></i> -->
                    <i class="fas fa-bell "></i>
                </button>
            </div>

            <div class="dropdown d-lg-inline-block" ngbDropdown>
                <button type="button" routerLink="Notifications" class="btn header-item noti-icon">
                    <i class="bx bx-bell "></i>
                    <span class="badge bg-danger rounded-pill">{{badgeCount}}</span>
                </button>

            </div>



            <div class="dropdown  d-none" ngbDropdown #dd1="ngbDropdown">
                <button type="button" class="btn header-item noti-icon" ngbDropdownToggle>
                    <i class="bx bx-customize"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end" ngbDropdownMenu>
                    <div class="px-lg-4">
                        <div class="row no-gutters moblie-view">
                            <div class="col-sm-4"
                                *ngIf="currentUser.riskAssisment || currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item border-0 cp" (click)="sidemenu(2, dd1)"
                                    routerLink="/dashboard">
                                    <i _ngcontent-wov-c343="" class="dripicons-warning fa-2x"></i>
                                    <span>Risk Management</span>
                                </a>
                            </div>
                            <div class="col-sm-4"
                                *ngIf="currentUser.cyberAssisment || currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item border-0 cp" (click)="sidemenu(10,dd1)"
                                    routerLink="/dashboard">
                                    <i class="mdi mdi-shield-lock-outline fa-2x"></i>
                                    <span>Cyber Risk Management</span>
                                </a>
                            </div>
                            <div class="col-sm-4" *ngIf="currentUser.crewRS || currentUser.role == Roles.SuperAdmin">
                                <!-- <span class="dropdown-icon-item"
                                    > -->
                                <a class="dropdown-icon-item border-0 cp" (click)="sidemenu(8,dd1)"
                                    routerLink="/dashboard">
                                    <i class="fas fa-tools fa-2x"></i>
                                    <span>Crew Competency Assessment</span>
                                </a>
                                <!-- </span> -->
                            </div>
                            <div class="col-sm-4" *ngIf="currentUser.audit || currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item border-0 cp" (click)="sidemenu(41,dd1)"
                                    routerLink="/dashboard">
                                    <i class="mdi mdi-file-eye-outline fa-2x"></i>
                                    <span>Audit</span>
                                </a>
                            </div>

                            <div class="col-sm-4" *ngIf="currentUser.cp || currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item border-0 cp" (click)="sidemenu(19,dd1)"
                                    routerLink="/dashboard">
                                    <i class="bx bx-cog fa-2x"></i>
                                    <span>Control Panel</span>
                                </a>
                            </div>

                            <div class="col-sm-4" *ngIf="currentUser.dms || currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item" routerLink="/crew-dms" (click)="sidemenu(55,dd1)">
                                    <i class="fas fa-solid fa-file fa-2x"></i>
                                    <span>Document Management System</span>
                                </a>
                            </div>
                            <div class="col-sm-4"
                                *ngIf="currentUser.gapAnalysis|| currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item" routerLink="/crew-dms" (click)="sidemenu(61,dd1)">
                                    <i class="fa-solid fa-chart-pie fa-2x"></i>
                                    <span> GapAnalysis</span>
                                </a>
                            </div>
                            <div class="col-sm-4" *ngIf="currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item" routerLink="/crew-dms" (click)="sidemenu(71,dd1)">
                                    <i class="fa-solid fa-ship fa-2x"></i>
                                    <span> IAIA</span>
                                </a>
                            </div>
                            <div class="col-sm-4" *ngIf="currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item" routerLink="/crew-dms" (click)="sidemenu(81,dd1)">
                                    <i class="fa-regular fa-file-lines fa-2x"></i>
                                    <span> Form Matrix</span>
                                </a>
                            </div>

                            <div class="col-sm-4" *ngIf="currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item" routerLink="/crew-dms" (click)="sidemenu(30,dd1)">
                                    <i class="fa-solid fa-ship fa-2x"></i>
                                    <span> KPI</span>
                                </a>
                            </div>


                            <!-- <div class="col-sm-4" *ngIf="currentUser.crewM || currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item" routerLink="/crew-matrix" (click)="sidemenu(51,dd1)">
                                    <i class="fas fa-users-cog fa-2x"></i>
                                    <span>Crew Matrix</span>
                                </a>
                            </div> -->

                            <!-- <div class="col-sm-4">
                                <a class="dropdown-icon-item border-0 cp" routerLink="/dashboard">
                                    <i _ngcontent-goy-c341="" class="bx bx-body fa-2x"></i>
                                    <span>Human Element</span>
                                </a>
                            </div>
                            <div class="col-sm-4" *ngIf="currentUser.moc || currentUser.role == Roles.SuperAdmin">
                                <a class="dropdown-icon-item border-0 cp" routerLink="/dashboard">
                                    <i class="bx bx-shuffle fa-2x"></i>
                                    <span>Management of Change</span>
                                </a>
                            </div>
                            <div class="col-sm-4">
                                <a class="dropdown-icon-item">
                                    <i class="fas fa-file-signature fa-2x"></i>
                                    <span>Inspections</span>
                                </a>
                            </div>
                            <div class="col-sm-4">
                                <a class="dropdown-icon-item" routerLink="/dashboard">
                                    <i class="bx bx-data fa-2x"></i>
                                    <span>TMSA DBMS</span>
                                </a>
                            </div>
                            <div class="col-sm-4">
                                <a class="dropdown-icon-item" routerLink="/dashboard">
                                    <i class="fas fa-ship fa-2x"></i>
                                    <span>DryBMS</span>
                                </a>
                            </div> -->
                        </div>
                        <div class="row no-gutters">
                        </div>
                    </div>
                </div>
            </div>
            <div class="dropdown d-none d-lg-inline-block ms-1">
                <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
                    <i class="bx bx-fullscreen"></i>
                </button>
            </div>
            <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item d-flex align-items-center" ngbDropdownToggle
                    id="page-header-user-dropdown">
                    <i class="far fa-user-circle fa-2x rounded-circle"></i>
                    <span class="d-none d-xl-inline-block ms-1">{{currentUser.name}}</span>
                    <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                    <a class="dropdown-item" routerLink="/Changepassword" *ngIf="!currentUser?.isOpenOceanUser"><i
                            class="bx bx-lock-open-alt
                        font-size-16 align-middle me-1 "></i>
                        Change password</a>
                    <div class="dropdown-divider" *ngIf="!currentUser?.isOpenOceanUser">

                    </div>
                    <a class="dropdown-item text-danger showCursor" (click)="logout()"><i
                            class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
                        {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</header>